import { render, staticRenderFns } from "./tasks-group-edit.vue?vue&type=template&id=3db51431&"
import script from "./tasks-group-edit.vue?vue&type=script&lang=js&"
export * from "./tasks-group-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miguelmesquita/Work/ui-all/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3db51431')) {
      api.createRecord('3db51431', component.options)
    } else {
      api.reload('3db51431', component.options)
    }
    module.hot.accept("./tasks-group-edit.vue?vue&type=template&id=3db51431&", function () {
      api.rerender('3db51431', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/recordm/fields/tasks-group-edit.vue"
export default component.exports